import type { EmployeesState } from './state';

export function setCurrentEmployee(
  state: EmployeesState, action: { payload: EmployeesState['currentEmployee'] },
) {
  state.currentEmployee = action.payload;
}
